import { useQuery, type UseQueryResult } from 'react-query';
import { type TableParams } from '../../types/common';
import {
  CharterFilingService,
  type PagedResultDto_CharterStockClassDto,
} from '@wealthlane/api-services/wealthlane-captable-service';
import { excludeDecimalFields } from '../../utils/apiDecimalConfig';

const useGetCharterStockClassList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams,
  charterFilingId?: string | null
): UseQueryResult<PagedResultDto_CharterStockClassDto | undefined, unknown> => {
  const { filter, sorting, skipCount, maxResultCount, classType } = tableInfo;

  return useQuery(
    ['getCharterStockClassList', charterFilingId, filter, sorting, skipCount, maxResultCount, classType],
    async () => {
      return await handleRequest(
        excludeDecimalFields(
          CharterFilingService.getApiCapTableApiAppCharterFilingStockClassListForCharter(
            charterFilingId ?? undefined,
            filter,
            classType,
            sorting,
            skipCount,
            maxResultCount
          ),
          ['items[].parValue', 'items[].originalIssuePrice', 'items[].dividendRate']
        )
      );
    }
  );
};

export default useGetCharterStockClassList;
